import { render, staticRenderFns } from "./TextboxSplited.vue?vue&type=template&id=46b3ebd4&"
import script from "./TextboxSplited.vue?vue&type=script&lang=js&"
export * from "./TextboxSplited.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports